import type { CommandBody } from '../CrossOriginMessage';

export class NewUserPreferencePatchOperation {
  ADD = 'add';
  REPLACE = 'replace';
  REMOVE = 'remove';
  MOVE = 'move';

  op: string;
  path: string;
  value: any;
  from?: any;
}

/**
 * Indicates the new user preferences.
 * Used to perform a patch in user preferences.
 */
export class NewUserPreferenceCommandBody implements CommandBody {
  _id: string;
  operations: NewUserPreferencePatchOperation[];
}
